import { useDictationStore } from "@/stores/dictation";

/** Global toast container — renders at the bottom of the app shell. */
export function Toaster() {
  const toasts = useDictationStore((s) => s.toasts);
  const dismiss = useDictationStore((s) => s.dismissToast);

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed bottom-6 right-6 z-50 flex flex-col gap-2">
      {toasts.map((t) => {
        const color =
          t.kind === "success"
            ? "bg-emerald-500 text-white"
            : t.kind === "error"
              ? "bg-rose-500 text-white"
              : "bg-slate-800 text-white";
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => dismiss(t.id)}
            className={`pointer-events-auto rounded-lg px-4 py-2 text-sm font-medium shadow-lg transition-opacity ${color}`}
          >
            {t.message}
          </button>
        );
      })}
    </div>
  );
}
